import { CategoricalColumn, CustomColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';
import React from 'react';

export const COL_NAMES = {
	url: 'url',
	fileName: 'fileName',
	expiry: 'expiry',
	backgroundColor: 'backgroundColor',
	deviceType: 'deviceType',
	minAppVersion: 'minAppVersion',
	maxAppVersion: 'maxAppVersion',
	isPreProd: 'isPreProd'
};

export const columnConfigs = [
	CustomColumn({
		title: 'Environment',
		maxWidth: 100,
		mapDataToValue: (data: any) => (data[COL_NAMES.isPreProd] ? 'Pre Prod' : 'Production'),
		renderCell: function Cell(props: any) {
			const { value } = props;
			return (
				<div
					style={{
						backgroundColor: value === 'Pre Prod' ? '#8B0000' : 'transparent',
						padding: '4px 8px',
						borderRadius: '4px'
					}}>
					{value}
				</div>
			);
		}
	}),
	CategoricalColumn({
		title: 'Platform',
		maxWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.deviceType] || EMPTY_STRING
	}),
	CategoricalColumn({
		title: 'URLS',
		maxWidth: 500,
		mapDataToValue: (data: any) => data[COL_NAMES.url] || EMPTY_STRING
	}),
	CategoricalColumn({
		title: 'Min App Version',
		minWidth: 10,
		maxWidth: 150,
		mapDataToValue: (data: any) => (data[COL_NAMES.minAppVersion] != null ? data[COL_NAMES.minAppVersion] : EMPTY_STRING)
	}),
	CategoricalColumn({
		title: 'Max App Version',
		maxWidth: 150,
		mapDataToValue: (data: any) => (data[COL_NAMES.maxAppVersion] != null ? data[COL_NAMES.maxAppVersion] : EMPTY_STRING)
	}),
	CategoricalColumn({
		title: 'File Name',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.fileName] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Expiry',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.expiry
	}),
	CategoricalColumn({
		title: 'Background Color',
		maxWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.backgroundColor] || EMPTY_STRING
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};
